import LinkedinAds from "../../../../contents/docs/cdp/sources/_snippets/source-linkedin-ads.mdx";
import * as React from 'react';
export default {
  LinkedinAds,
  React
};